import { useTranslation } from "react-i18next"

import { Badge } from "@/components/ui/badge"
import type { MissionAudience } from "@/types/missions"

/**
 * OKS-467 — Static "All crew" indicator for the brand mission surfaces
 * (Index rows + Show header). Renders only when the mission's audience is
 * `all_crew`, signalling that the mission auto-assigns future joiners.
 *
 * Accessibility (UX Spec §6): the badge carries the text label "All crew"
 * — colour is decorative, never the sole signal — so screen readers
 * announce the targeting next to the mission status. Non-interactive.
 *
 * @param audience - the mission's audience enum value.
 */
export function AllCrewBadge({ audience }: { audience: MissionAudience }) {
  const { t } = useTranslation()

  if (audience !== "all_crew") return null

  return (
    <Badge variant="secondary" data-testid="mission-all-crew-badge">
      {t("missions.audience.all_crew")}
    </Badge>
  )
}
